export default __webpack_public_path__ + "static/media/Italian.2e3cea7d.mp3";